import { serviceAxiosInstance, serviceAxiosInstanceFcna } from '../config/api.service.config';
import { ENDPOINTS } from '../constants/endpoints';

export function updateAssignment(assignmentInfo) {
  return serviceAxiosInstance.put(
    ENDPOINTS['UPDATE_ASSIGNMENT'] +
    '?agentAction=' +
    assignmentInfo.agentAction +
    '&bpiNb=' +
    assignmentInfo.bpiNb +
    '&confirm=' +
    assignmentInfo.confirm +
    '&csrAction=' +
    assignmentInfo.csrAction +
    '&cntrctrNb=' +
    assignmentInfo.cntrctrNb +
    '&supApproval=' +
    assignmentInfo.supApproval +
    '&userId=' +
    assignmentInfo.userId
  );
}
export function getVechileDisposalInfo(customerAccoutNumber, cobusCode, origBranch) {
  return serviceAxiosInstanceFcna.get(
    ENDPOINTS['VECHICLE_DISPOSAL_INFO_BASE_URL'] +
    cobusCode +
    '/' +
    origBranch +
    '/' +
    customerAccoutNumber
  );
}
export function CreateVehicleDisposalInfo(insertvehicladisposaldata) {
  return serviceAxiosInstanceFcna.post(
    ENDPOINTS['VECHICLE_DISPOSAL_INFO_BASE_URL'],
    insertvehicladisposaldata
  );
}
export function UpdateVehicleDisposalInfo(customerAccoutNumber, cobusCode, origBranch, updatevehicleDisposaldata1) {
  return serviceAxiosInstanceFcna.post(
    ENDPOINTS['VECHICLE_DISPOSAL_INFO_BASE_URL'] +
    cobusCode +
    '/' +
    origBranch +
    '/' +
    customerAccoutNumber,
    updatevehicleDisposaldata1
  );
}

export function getAuctionLocationList(countrycode) {
  return serviceAxiosInstanceFcna.get(ENDPOINTS['GET_AUCTION_LOCATION'] + countrycode);
}

export function FcnaDB2Postcall(transactionObj) {
  return serviceAxiosInstanceFcna.post(ENDPOINTS['POST_FCNADB2'], transactionObj);
}
